import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { QueryTestComponent } from './query.test.component';
import { FormsModule } from '@angular/forms';
import { CommonModule} from '@angular/common'
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
    imports:[
    RouterModule.forChild([{path: 'querytest', component: QueryTestComponent}]),
        FormsModule,
        CommonModule,
        NgxSpinnerModule
        ]
  ,
  declarations:[
    QueryTestComponent,
  ]
})

export class TestQueryModule {}